import maxBy from 'lodash/maxBy';
import { PartySizeOption } from '../components/shared/PartySizeDropdown';

export const getMaxSupportedGroupSize = (options: PartySizeOption[]) => {
	return +maxBy(options, (option) => !option.inboundRequest && +option.value)?.value;
};
